export class NotFoundRegisteredCertificateError extends Error {}
export class NotFoundLocalCertificatesError extends Error {}
export class NotFoundMatchedCertificatesError extends Error {}
export class InvalidFileError extends Error {}
